/**
 * Angular bootstrap Date adapter
 */
import { Injectable } from '@angular/core';
import { NgbDateAdapter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import dayjs, { Dayjs } from 'dayjs';

@Injectable()
export class NgbDateDayjsAdapter extends NgbDateAdapter<Dayjs> {
  fromModel(date: Dayjs): NgbDateStruct {
    if (date && date.isValid()) {
      return { year: date.year(), month: date.month() + 1, day: date.date() };
    }
    // ! can be removed after https://github.com/ng-bootstrap/ng-bootstrap/issues/1544 is resolved
    return null!;
  }

  toModel(date: NgbDateStruct): Dayjs {
    // ! after null can be removed after https://github.com/ng-bootstrap/ng-bootstrap/issues/1544 is resolved
    return date ? dayjs(date.year + '-' + date.month + '-' + date.day, 'YYYY-MM-DD') : null!;
  }
}
